import React from "react";
import { connect } from "react-redux";
import moment from 'moment';
import ClaimsHeader from "./Components/ClaimsHeader/ClaimsHeader";
import Grid from "@material-ui/core/Grid";
import Principal from "../../../containers/Policyv2/Components/Principal/Principal";
import ClaimInitiationWrapper from "./Components/ClaimInitiationWrapper/ClaimInitiationWrapper";
import { getCustomer } from "../../../containers/Customer/actions.es6";
import *  as actions from "./Redux/actions"
import SelectPolicy from "./Components/SelectPolicy/SelectPolicy";
import SelectMember from "./Components/SelectMember/SelectMember";
import ClaimLoggingDetails from "./Components/ClaimLoggingDetails/ClaimLoggingDetails";
import ClaimDetails from "./Components/ClaimDetails/ClaimDetails";
import { getUserFullname, getUserGuid } from "../../../lib/access.es6";
import AdditionalDetails from "./Components/AdditionalDetails/AdditionalDetails";
import find from 'lodash/find';
//import { getAllPoliciesRequest } from "../CustomerStatus/Redux/actions";
import { getAllPoliciesRequest } from "../../MalipoWws/CustomerStatus/Redux/actions";
import ClaimSummary from "./Components/ClaimSummary/ClaimSummary";

class ClaimInitiation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      claimInitiationPayload: {
        "event_date": null,
        "policy_guid": null,
        "policy_number": null,
        "quotation_guid": null,
        "customer_guid": null,
        "dependant_guid": null,
        "partner": null,
        "benefits": [],
        "next_of_kin": {},
        "initiator_fullname": null,
        "initiator_msisdn": null,
        "web_agent_guid": null,
        "web_agent_name": null,
        "additional_details": null,
        "claimant_msisdn": null,
        "claimant_email": null,
        "claimant_first_name": null,
        "claimant_last_name": null,
        "type_of_claim": null,
      },

      "claimant_phone_number": '',
      "claimant_full_name": '',
      "claimant_id_number": '',
      "claimant_relationship_to_patient": '',
      "admission_date": '',
      "discharge_date": '',
      "number_of_days_in_hospital": '',
      "date_of_death": '',
      "funeral_home_name": '',
      "death_certficate_number": '',
      "device_number": '',
      "date_of_damage": '',
      "date_of_disability": '',
      "date_of_theft": '',
     "beneficiary_national_id": '',
     "loan_amount": '',
     "loan_disbursement_date": '',
     "loan_duration": '',
     "loan_maturity_date": '',
     "loan_type": '',
     "monthly_installment_amount": '',
     "real_people_commission": '',
     "loan_interest_rate": '',
     "product_code": '',
     "monthly_interest_rate": '',
     "location_of_business": '',
     "type_of_business": '',
     "policy_start_date": '',
     "date_of_event": '',
     "details_of_event": '', 
     "hospital_attended": '',
     "inpatient_number": '',
     "cause_of_hospitilization": '',
     "weakly_loan_amount": '',
     "nature_of_illnes_or_disability": '',
     "patient_number": '',
     "outstanding_loan_amount_at_date_of_event": '',
     "cause_of_death": '',
     "type_of_cancer": '',
     "claimant_bank_name": '',
     "claimant_bank_branch": '',
      "claimant_bank_account_number": '',
      "claimant_mpesa_phone_number": '',
      "claimant_payment_option": '',
      "claimant_omang_number": '',
      "claimant_mobile_money_number": '',
      "claimant_mobile_money_provider": '',
      "incident_date": '',
      "car_registration": '',
      "incident_location": '',
      "incident_time": '',
      "assistance_type": '',
      "nature_of_case": '',
      "type_of_dispute": '',
      "brief_description": '',
      "age": '',
      estimated_distance_towed: '',
      "type_of_disability": '',
      "attending_physician": '',
      "patient_age": '',
      "type_of_claim": '',
      "carrying_status": '',
      claimSummaryData: {}
    };
}

  setAdditionalState(name, value){
    this.setState({[name]: value})
  }

  componentWillMount() {

     let customer_guid = this.props.params.customer_guid
    if (customer_guid) {
      this.refreshCustomerDetails(customer_guid)
    }
    if(customer_guid){
      this.props.dispatch(getAllPoliciesRequest({ guid: customer_guid }))
    }


    if (customer_guid) {
      this.props.dispatch(actions.getCustomerClaimsDcpRequest({
        guid: customer_guid
      })
      );
    }


  }


	refreshCustomerDetails(customer_guid) {
    this.props.dispatch(getCustomer(customer_guid))

	}
  
   getAge(){
    const member = this.state.claimInitiationPayload.member ? this.state.claimInitiationPayload.member.dependant : null

    if (member) {

      const dob = member.date_of_birth;
      const currentDate = moment();
      const birthDate = moment(dob);
      const currentAge = currentDate.diff(birthDate, 'years');
      return currentAge;
    }
    return ""
  };

  handleSelectPolicies(payload) {
    this.props.dispatch(actions.getEventQuoteRequest(payload));
  }

  handleClaimSummary() {
    let payload = this.state.claimInitiationPayload;
    payload['policy_guid'] = this.props.claimInitiationData.eventQuote.policy_guid;
    payload['policy_number'] = this.state.claimInitiationPayload.policy_number;
    payload['quotation_guid'] = this.props.claimInitiationData.eventQuote.guid;
    payload['customer_guid'] = this.props.claimInitiationData.eventQuote.customer_guid;
    payload['partner'] = this.props.claimInitiationData.eventQuote.partner;
    payload['web_agent_guid'] = getUserGuid();
    payload['web_agent_name'] = getUserFullname();

    payload = {
      ...payload,
      policy_number2: this.state.claimInitiationPayload.policy_number,
      initiator_fullname: this.state.claimant_full_name,
      initiator_msisdn: this.state.claimant_phone_number,
      claimant_msisdn: this.state.claimant_phone_number,
      claimant_email: this.state.claimant_email,
      claimant_first_name: this.state.claimant_full_name.split(' ')[0],
      claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
      additional_details: {
        ...payload.additional_details,
        admission_date: this.state.claimInitiationPayload.event_date,
        discharge_date: this.state.discharge_date,
        number_of_days_in_hospital: this.state.number_of_days_in_hospital,
        date_of_death: this.state.claimInitiationPayload.event_date,
        funeral_home_name: this.state.funeral_home_name,
        death_certficate_number: this.state.death_certficate_number,
        device_number: this.state.device_number,
        date_of_damage: this.state.date_of_damage,
        date_of_disability: this.state.date_of_disability,
        date_of_theft: this.state.date_of_theft,
        installment_amount: this.state.installment_amount,
        claimant_full_name: this.state.claimant_full_name,
        claimant_id_number: this.state.claimant_id_number,
        claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
        claimant_bank_name: this.state.claimant_bank_name,
        claimant_bank_account_number: this.state.claimant_bank_account_number,
        claimant_bank_branch: this.state.claimant_bank_branch,
        claimant_mpesa_phone_number: this.state.claimant_mpesa_phone_number,
        claimant_payment_option: this.state.claimant_payment_option,
        claimant_omang_number: this.state.claimant_omang_number,
        claimant_mobile_money_number: this.state.claimant_mobile_money_number,
        claimant_mobile_money_provider: this.state.claimant_mobile_money_provider,
        age: this.getAge(),
        beneficiary_national_id: this.state.beneficiary_national_id,
        loan_amount: this.state.loan_amount,
        loan_disbursement_date: this.state.loan_disbursement_date,
        loan_duration: this.state.loan_duration,
        loan_maturity_date: this.state.loan_maturity_date,
        loan_type: this.state.loan_type,
        monthly_installment_amount: this.state.monthly_installment_amount,
        real_people_commission: this.state.real_people_commission,
        loan_interest_rate: this.state.loan_interest_rate,
        product_code: this.state.product_code,
        monthly_interest_rate: this.state.monthly_interest_rate,
        location_of_business: this.state.location_of_business,
        type_of_business: this.state.type_of_business,
        policy_start_date: this.state.policy_start_date,
        date_of_event: this.state.date_of_event,
        details_of_event: this.state.details_of_event,
        hospital_attended: this.state.hospital_attended,
        inpatient_number: this.state.inpatient_number,
        cause_of_hospitilization: this.state.cause_of_hospitilization,
        weakly_loan_amount: this.state.weakly_loan_amount,
        nature_of_illnes_or_disability: this.state.nature_of_illnes_or_disability,
        patient_number: this.state.patient_number,
        outstanding_loan_amount_at_date_of_event: this.state.outstanding_loan_amount_at_date_of_event,
        cause_of_death: this.state.cause_of_death,
        type_of_cancer: this.state.type_of_cancer,
        incident_date: this.state.event_date,
        car_registration: this.state.car_registration,
        incident_location: this.state.incident_location,
        incident_time: this.state.incident_time,
        assistance_type: this.state.assistance_type,
        nature_of_case: this.state.nature_of_case,
        type_of_dispute: this.state.type_of_dispute,
        estimated_distance_towed: this.state.estimated_distance_towed,
        carrying_status: this.state.carrying_status,
        brief_description: this.state.brief_description,
        type_of_claim: this.state.type_of_claim,
        type_of_disability: this.state.type_of_disability,
        attending_physician: this.state.attending_physician,
        patient_age: this.state.patient_age,
      }
    }

    this.setState({claimSummaryData: payload})
  }

  handleInitiateClaim() {
    let payload = this.state.claimInitiationPayload;
    payload['policy_guid'] = this.props.claimInitiationData.eventQuote.policy_guid;
    payload['policy_number'] = this.state.claimInitiationPayload.policy_number;
    payload['quotation_guid'] = this.props.claimInitiationData.eventQuote.guid;
    payload['customer_guid'] = this.props.claimInitiationData.eventQuote.customer_guid;
    payload['partner'] = this.props.claimInitiationData.eventQuote.partner;
    payload['web_agent_guid'] = getUserGuid();
    payload['web_agent_name'] = getUserFullname();

    payload = {
      ...payload,
      policy_number2: this.state.claimInitiationPayload.policy_number,
      initiator_fullname: this.state.claimant_full_name,
      initiator_msisdn: this.state.claimant_phone_number,
      claimant_email: this.state.claimant_email,
      claimant_first_name: this.state.claimant_full_name.split(' ')[0],
      claimant_last_name: this.state.claimant_full_name.split(' ')[1] || '',
      claimant_msisdn: this.state.claimant_phone_number,
      additional_details: {
        ...payload.additional_details,
        admission_date: this.state.claimInitiationPayload.event_date,
        discharge_date: this.state.discharge_date,
        number_of_days_in_hospital: this.state.number_of_days_in_hospital,
        date_of_death: this.state.event_date,
        funeral_home_name: this.state.funeral_home_name,
        death_certficate_number: this.state.death_certficate_number,
        device_number: this.state.device_number,
        date_of_damage: this.state.date_of_damage,
        date_of_disability: this.state.date_of_disability,
        date_of_theft: this.state.date_of_theft,
        installment_amount: this.state.installment_amount,
        claimant_full_name: this.state.claimant_full_name,
        claimant_id_number: this.state.claimant_id_number,
        claimant_relationship_to_patient: this.state.claimant_relationship_to_patient,
        claimant_bank_name: this.state.claimant_bank_name,
        claimant_bank_branch: this.state.claimant_bank_branch,
        claimant_bank_account_number: this.state.claimant_bank_account_number,
        claimant_mpesa_phone_number: this.state.claimant_mpesa_phone_number,
        claimant_payment_option: this.state.claimant_payment_option,
        claimant_omang_number: this.state.claimant_omang_number,
        claimant_mobile_money_number: this.state.claimant_mobile_money_number,
        claimant_mobile_money_provider: this.state.claimant_mobile_money_provider,
        age: this.getAge(),
        beneficiary_national_id: this.state.beneficiary_national_id,
        loan_amount: this.state.loan_amount,
        loan_disbursement_date: this.state.loan_disbursement_date,
        loan_duration: this.state.loan_duration,
        loan_maturity_date: this.state.loan_maturity_date,
        loan_type: this.state.loan_type,
        monthly_installment_amount: this.state.monthly_installment_amount,
        real_people_commission: this.state.real_people_commission,
        loan_interest_rate: this.state.loan_interest_rate,
        product_code: this.state.product_code,
        monthly_interest_rate: this.state.monthly_interest_rate,
        location_of_business: this.state.location_of_business,
        type_of_business: this.state.type_of_business,
        policy_start_date: this.state.policy_start_date,
        date_of_event: this.state.event_date,
        details_of_event: this.state.details_of_event,
        hospital_attended: this.state.hospital_attended,
        inpatient_number: this.state.inpatient_number,
        cause_of_hospitilization: this.state.cause_of_hospitilization,
        weakly_loan_amount: this.state.weakly_loan_amount,
        nature_of_illnes_or_disability: this.state.nature_of_illnes_or_disability,
        patient_number: this.state.patient_number,
        outstanding_loan_amount_at_date_of_event: this.state.outstanding_loan_amount_at_date_of_event,
        cause_of_death: this.state.cause_of_death,
        type_of_cancer: this.state.type_of_cancer,
        incident_date: this.state.event_date,
        car_registration: this.state.car_registration,
        incident_location: this.state.incident_location,
        incident_time: this.state.incident_time,
        assistance_type: this.state.assistance_type,
        nature_of_case: this.state.nature_of_case,
        type_of_dispute: this.state.type_of_dispute,
        estimated_distance_towed: this.state.estimated_distance_towed,
        carrying_status: this.state.carrying_status,
        brief_description: this.state.brief_description,
        type_of_claim: this.state.type_of_claim,
        type_of_disability: this.state.type_of_disability,
        attending_physician: this.state.attending_physician,
        patient_age: this.state.patient_age,
      }
    }

    console.log('payload: ', payload);
    this.props.dispatch(actions.initiateClaimRequest(payload));
  }

  render() {


    if (!this.props.customerData.currentCustomer) {
      return "Loading...";
  }
  const accidentalDeathDisabilty = !!find(this.state.claimInitiationPayload.benefits, {type: "Accidental death and disability cover P 50,000"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "Accidental death and disability cover P 20,000"}) || !!find(this.state.claimInitiationPayload.benefits, {type: "AccidentaldeathanddisabilitycoverP20000"})
  const hasMedicashIllnessBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Medical Cash Plan"})
  const hasLegalCoverBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Legal Cover"})
  const hasRoadsideAssistanceBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Roadside Assistance"})
  const hasBDFandPrisonsBenefit = !!find(this.state.claimInitiationPayload.benefits, {type: "Police, Prisons, and BDF disciplinary Boards"})


    return (
      <>
        <ClaimsHeader title="Initiate Claim " />
        <Grid container spacing={2}>
          <Grid xs={12} md={3} sm={3}>
            <Principal
              customerData={this.props.customerData.currentCustomer}
              loader={false}
            />
          </Grid>
          <ClaimInitiationWrapper
            policies={this.props.customerStatusV2Data.policies}
            handleSelectPolicies={this.handleSelectPolicies.bind(this)}
            selectedMember={this.props.claimInitiationData.selectedPolicy}
            eventQuote={this.props.claimInitiationData.eventQuote}
            customerClaimsDcp={
              this.props.claimInitiationData.customer_claims_dcp
            }
            handleInitiateClaim={this.handleInitiateClaim.bind(this)}
            createdClaim={this.props.claimInitiationData.initiateClaim}
            handleClaimSummary={this.handleClaimSummary.bind(this)}
            admissionDate={this.state.claimInitiationPayload.event_date}
            dischargeDate={this.state.discharge_date}
            dateOfDeath={this.state.claimInitiationPayload.event_date}
            hospital_attended={this.state.hospital_attended}
            cause_of_hospitilization={this.state.cause_of_hospitilization}
            inpatient_number={this.state.inpatient_number}
            number_of_days_in_hospital={this.state.number_of_days_in_hospital}
            funeral_home_name={this.state.funeral_home_name}
            death_certficate_number={this.state.death_certficate_number}
            hasRoadsideAssistanceBenefit={hasRoadsideAssistanceBenefit}
            hasLegalExpenseBenefit={hasLegalCoverBenefit}
            hasBDFandPrisonsBenefit={hasBDFandPrisonsBenefit}
            hasHospiCashIllnessBenefit={hasMedicashIllnessBenefit}
            hasAccidentalDeathBenefits={accidentalDeathDisabilty}
            claimPayload={this.state}
            components={{
              SelectPolicy: (
                <SelectPolicy
                  policies={this.props.customerStatusV2Data.policies}
                  customerData={this.props.customerData.currentCustomer}
                  handleSelectPolicies={this.handleSelectPolicies.bind(this)}
                  eventQuoteSuccess={
                    this.props.claimInitiationData.eventQuoteSuccess
                  }
                  eventQuoteLoader={
                    this.props.claimInitiationData.eventQuoteLoader
                  }
                  eventQuoteError={
                    this.props.claimInitiationData.eventQuoteError
                  }
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                />
              ),
              SelectMember: (
                <SelectMember
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  setAdditionalState={this.setAdditionalState.bind(this)}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    }) 
                  }
                />
              ),

              AdditionalDetails: (
                <AdditionalDetails
                  hasAccidentalDeathBenefits={accidentalDeathDisabilty}
                  hasLegalCoverBenefit={hasLegalCoverBenefit}
                  hasRoadsideAssistanceBenefit={hasRoadsideAssistanceBenefit}
                  hasMediCashIllnessBenefit={hasMedicashIllnessBenefit}
                  hasBDFandPrisonsBenefit={hasBDFandPrisonsBenefit}
                  handleInitiateClaim={this.handleInitiateClaim.bind(this)}
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  claimState={this.state}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                  member={
                    this.state.claimInitiationPayload.member
                      ? this.state.claimInitiationPayload.member.dependant
                      : null
                  }
                  eventDate={this.state.claimInitiationPayload.event_date}
                  setAdditionalState={this.setAdditionalState.bind(this)}
                  eventData={this.props.claimInitiationData.eventQuote}
                />
              ),

              ClaimLoggingDetails: (
                <ClaimLoggingDetails
                  handleInitiateClaim={this.handleInitiateClaim.bind(this)}
                  eventQuote={this.props.claimInitiationData.eventQuote}
                  claimState={this.state}
                  nextOfKin={this.state.claimInitiationPayload.next_of_kin}
                  isLegalCover={hasLegalCoverBenefit}
                  setClaimInitiationPayload={(newClaimInitiationPayload) =>
                    this.setState({
                      claimInitiationPayload: newClaimInitiationPayload,
                    })
                  }
                  setAdditionalState={this.setAdditionalState.bind(this)}
                />
              ),

              ClaimSummary: (
                <ClaimSummary
                  claimInitiationPayload={this.state.claimInitiationPayload}
                  typeOfClaim={this.state.type_of_claim}
                  claimSummaryData={this.state.claimSummaryData}
                  hasAccidentalDeathBenefits={accidentalDeathDisabilty}
                  hasHospiCashIllnessBenefit={hasMedicashIllnessBenefit}
                  hasLegalCoverBenefit={hasLegalCoverBenefit}
                  hasRoadsideAssistanceBenefit={hasRoadsideAssistanceBenefit}
                  hasBDFandPrisonsBenefit={hasBDFandPrisonsBenefit}
                />
              ),
              ClaimDetails: (
                <ClaimDetails
                  claimDetailsData={
                    this.props.claimInitiationData.initiateClaim
                  }
                  initiateClaimLoader={
                    this.props.claimInitiationData.initiateClaimLoader
                  }
                />
              ),
            }}
          />
        </Grid>
      </>
    );
  }

}

export default connect((state) => ({
  customerData: state.currentCustomer,
  claimInitiationData: state.claimInitiationData,
  customerStatusV2Data: state.customerStatusV2Data,
  userData: state.userAdmin,
  globalData: state.global,
}))(ClaimInitiation);